<template>
    <el-card class="box-card">
        <el-alert
                v-if="! truck.currentLocation"
                title="Sorry, Freighthub can't get the current location of the truck."
                type="error"
                center
                show-icon>
        </el-alert>
        <el-alert
                v-if="! locationCoordinates"
                title="Sorry, Freighthub can't get your location."
                type="error"
                center
                show-icon>
        </el-alert>
        <GmapMap
            ref="map"
            style="height:70vh"
            :zoom=mapParams.zoom
            :center=mapParams.center
        >
            <Gmap-Marker
                v-if="truck.currentLocation"
                :position="{
                    lat: Number(truck.currentLocation.data.lat),
                    lng: Number(truck.currentLocation.data.lng)
                }"
                :icon=truckIcon
                @click="infoWindow = truck">
            </Gmap-Marker>
            <Gmap-Marker
                v-if="locationCoordinates"
                :position="{
                    lat: Number(locationCoordinates.lat),
                    lng: Number(locationCoordinates.lng)
                }"
            >
            </Gmap-Marker>
            <Gmap-Info-Window
                    v-if="infoWindow !== null"
                    :opened="infoWindow !== null"
                    :position="{ lat: infoWindow.currentLocation.data.lat, lng: infoWindow.currentLocation.data.lng }"
                    @closeclick="infoWindow = null">
                <b>Truck: </b>{{ infoWindow.plate }}
                <br><b>Status: </b>{{ infoWindow.currentLocation.data.speed }}km/h {{ moment(infoWindow.currentLocation.data.time).fromNow() }} ({{ moment(infoWindow.currentLocation.data.time).format('h:mm:ss a, ddd Do MMM \'YY') }})
                <br><b>Location: </b>{{ infoWindow.currentLocation.data.location.replace(', New Zealand', '') }}
            </Gmap-Info-Window>
        </GmapMap>
        <el-alert
                v-if="truck.currentLocation"
                title="The truck may go to other customers before coming to you."
                type="info"
                center
                show-icon>
        </el-alert>
    </el-card>
</template>

<script>
    import moment from 'moment';
    import { gmapApi } from 'vue2-google-maps'
    import { RotateIcon } from "../../utility/utility";

    export default {
        // Do not forget this little guy
        name: 'GuestTrackTruck',
        // share common functionality with component mixins
        mixins: [],
        // compose new components
        extends: {},
        // component properties/variables
        props: ['locationCoordinates', 'truck'],
        // variables
        data() {
            return {
                infoWindow: null,
                truckIcon: null,
            }
        },
        computed: {
            google: gmapApi,
            mapParams: function () {
                return {
                    center: {
                        lat: -41.543,
                        lng: 174.0277
                    },
                    zoom: 6,
                }
            },
        },
        // when component uses other components
        components: {
        },
        // methods
        methods: {
            moment,
            updateTruckIcon() {
                this.truckIcon = {
                    url: '/images/truck_icon_greenv1.svg',
                    scaledSize: new this.google.maps.Size(60, 60), // scaled size
                    origin: new this.google.maps.Point(0, 0), // origin
                    anchor: new this.google.maps.Point(30, 30) // anchor
                };
                if (this.truck) {
                    RotateIcon.makeIcon('/images/truck_icon_greenv1.svg')
                        .then(rotateIcon => {
                            const course = Number.parseInt(this.truck.currentLocation.data.course_over_ground);
                            const url = rotateIcon.setRotation({deg: course}).getUrl();
                            this.truckIcon = {
                                url: url,
                                scaledSize: new this.google.maps.Size(60, 60), // scaled size
                                origin: new this.google.maps.Point(0, 0), // origin
                                anchor: new this.google.maps.Point(30, 30) // anchor
                            }
                        }).catch( e => console.log(e));
                }
            }
        },
        mounted() {
            this.$refs.map.$mapPromise.then((map) => {
                //create the truck icon
                this.updateTruckIcon();

                //fit the map's bounds
                var bounds = new google.maps.LatLngBounds();
                var points = [];
                if (this.truck && Number(this.truck.currentLocation.data.lat && Number(this.truck.currentLocation.data.lng))) {
                    points.push(new google.maps.LatLng(Number(this.truck.currentLocation.data.lat), Number(this.truck.currentLocation.data.lng)));
                }
                if (Number(this.locationCoordinates.lat) && Number(this.locationCoordinates.lng)) {
                    points.push(new google.maps.LatLng(Number(this.locationCoordinates.lat), Number(this.locationCoordinates.lng)));
                }
                // Extend bounds with each point
                for (var i = 0; i < points.length; i++) {
                    bounds.extend(points[i]);
                }
                // Apply fitBounds
                map.fitBounds(bounds);
            })
        }
    };
</script>

<style scoped>
    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 100%;
        margin-top: 20px;
    }
</style>
